import { toast } from 'react-toastify'
import useSWR, { SWRConfiguration } from 'swr'
import { learningApi } from '../../../services/api'
import { IFiltersData } from '../components/SearchQuestionsContent/types'

export function useGetFiltersData() {
  const token = localStorage.getItem('token')

  const key = token ? '/question/filters/all' : null

  const swr = useSWR<IFiltersData>(key, fetcher(token), configuration)

  return swr
}

const fetcher = (token: string) => (url: string) =>
  learningApi
    .get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)

const configuration: SWRConfiguration<IFiltersData> = {
  fallbackData: {
    subjects: [],
    years: [],
    evaluatingInstitutions: [],
    schooling: [],
    publicTenders: [],
    roles: [],
    graduation: [],
  },
  onError() {
    toast.error('Não foi possível carregar os filtros de questões. Tente novamente mais tarde.')
  },
  errorRetryCount: 0,
}
